import { Component, Input, OnDestroy, ViewChild, OnInit } from '@angular/core';
import { HttpRepositoryService } from '../../core/http-repository.service';
import { UserProfile } from '../user-profile.model';
import { UserProfileService } from '../user-profile.service';
import { NgForm } from '@angular/forms';
import { AntiForgeryTokenService } from '../../auth/anti-forgery-token.service';
import { MessageDialogComponent } from '../../core/message-dialog/message-dialog.component';
import { MessageType } from '../../core/message-dialog/message-type.enum';
import { SubSink } from 'subsink';

declare var Toast: any;
declare var $: any;

@Component({
  selector: 'user-profile-basic-info',
  templateUrl: './user-profile-basic-info.component.html',
  styleUrls: ['./user-profile-basic-info.component.css']
})

export class UserProfileBasicInfoComponent implements OnInit, OnDestroy {

  @Input() private user: UserProfile

  private modalId: string;
  private subs = new SubSink();

  @ViewChild('editForm', { static: false }) editForm: NgForm;
  @ViewChild('basicInfoMsg', { static: false }) msgDialog: MessageDialogComponent;

  constructor(private repository: HttpRepositoryService, private userService: UserProfileService, private antiForgery: AntiForgeryTokenService) { }

  ngOnInit() {
    this.modalId = 'basicInfoMsg';
  }

  private editBasicInfo() {
    if (this.editForm.valid) {
      this.msgDialog.show('Are you sure you change basic info?', MessageType.YESNO, 'Update basic info!', () => {

        this.subs.sink = this.antiForgery.getAFToken().subscribe(afResp => {
          if (afResp.hasErrors) {
            Toast.Show(afResp.error, 'Update basic info failed.', 'error');
          } else {
            this.subs.sink = this.repository.put<UserProfile>('api/User/EditUserBasicInfo', this.user, afResp.data).subscribe(resp => {
              if (resp.hasErrors) {
                Toast.Show(resp.error, 'Update basic info failed.', 'error');
              } else {
                Toast.Show('Basic info succsessfully changed', 'User profile', 'success');
                this.changeUserBasicInfo(resp.data.firstName, resp.data.lastName);
              }
            });
          }
        });
      });

      

    } else {
      Object.keys(this.editForm.controls)
        .forEach(fieldName => {
          this.editForm.controls[fieldName].markAsDirty();
        });
      $('#firstName').focus();
    }
  }

  private changeUserBasicInfo(firstName: string, lastName: string) {
    this.userService.changeUserFirstName(firstName);
    this.userService.changeUserLastName(lastName);
  }

  ngOnDestroy() {
    this.subs.unsubscribe();
  }
}
